/* Liberty Loan Network — loan-estimator.js
   Client-side, non-binding payment sketch. Informational only — the visible
   disclaimer in the section carries the compliance language. */

(function () {
  "use strict";

  function formatMoney(value) {
    var rounded = Math.round(value);
    return "$" + String(rounded).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  function monthlyPayment(principal, annualRate, months) {
    var r = annualRate / 12;
    if (r === 0) return principal / months;
    var factor = Math.pow(1 + r, months);
    return (principal * r * factor) / (factor - 1);
  }

  function initEstimator(root) {
    var amountInput = root.querySelector("[data-amount]");
    var termInput = root.querySelector("[data-term]");
    var purposeInput = root.querySelector("[data-purpose]");
    var amountOut = root.querySelector("[data-amount-out]");
    var termOut = root.querySelector("[data-term-out]");
    var result = root.querySelector("[data-result]");

    if (!amountInput || !termInput || !result) return;

    var APR_LOW = 0.0699;
    var APR_HIGH = 0.2499;

    function relight() {
      result.classList.remove("is-lit");
      /* Forced reflow so the underline draw re-triggers on every change */
      void result.offsetWidth;
      result.classList.add("is-lit");
    }

    function update() {
      var amount = parseInt(amountInput.value, 10) || 0;
      var months = parseInt(termInput.value, 10) || 12;

      if (amountOut) amountOut.textContent = formatMoney(amount);
      if (termOut) termOut.textContent = months + " months";

      var low = monthlyPayment(amount, APR_LOW, months);
      var high = monthlyPayment(amount, APR_HIGH, months);

      result.textContent = formatMoney(low) + " \u2013 " + formatMoney(high);
      relight();
    }

    amountInput.addEventListener("input", update);
    termInput.addEventListener("input", update);
    if (purposeInput) purposeInput.addEventListener("input", update);

    update();
  }

  function init() {
    var roots = document.querySelectorAll("[data-estimator]");
    Array.prototype.forEach.call(roots, initEstimator);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
